import React from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

export default function ClientSwitcher() {
  const { user, loading, switchClient } = useAuth();
  const navigate = useNavigate();
  if (!user?.memberships?.length) return null;
  if (user.memberships.length === 1) {
    const membership = user.memberships[0];
    return <span>{membership.client_name || `Client ${membership.client_id}`}</span>;
  }
  return <label className="inline-flex min-w-0 items-center">
    <select aria-label="Client" value={user.client_id ?? ""} disabled={loading}
      className="max-w-48 rounded-md border border-slate-300 bg-white px-2 py-2 text-lg font-bold text-slate-950 sm:max-w-sm"
      onChange={(event) => {
        const id = event.target.value;
        navigate("/agents", { replace: true });
        switchClient(id).catch(() => {});
      }}>
      {user.memberships.map((membership) => <option key={membership.client_id} value={membership.client_id}>
        {membership.client_name || `Client ${membership.client_id}`}
      </option>)}
    </select>
  </label>;
}
